var TokenLoginPageController = /** @class */ (function () {
    /*@ngInject*/
    function TokenLoginPageController($rootScope, $state, $scope, modalService, authService, moment, StorageService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.modalService = modalService;
        this.authService = authService;
        this.moment = moment;
        this.StorageService = StorageService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    TokenLoginPageController.prototype.$onInit = function () {
        this.$stateParams = this.$transition$.params();
        // params
        this.token = this.$stateParams.t;
        this.action = this.$stateParams.a;
        this.outreachId = this.$stateParams.o ? this.$stateParams.o : null;
        this.candidateId = this.$stateParams.cid ? this.$stateParams.cid : null;
        this.companyId = this.$stateParams.comp ? this.$stateParams.comp : null;
        this.userIdsArray = [];
        this.tokenData = {};
        // flags
        this.loadingFlag = true;
        this.authenticatedFlag = false;
        this.isUserAlreadyLoggedIn = false;
        this._handleUserNavigation();
    };
    TokenLoginPageController.prototype._handleUserNavigation = function () {
        var _this = this;
        var userDetails = angular.copy(this.StorageService.get('userDetails'));
        //User's session already active
        if (userDetails && this.action != 'Outreach') {
            this.authService.getUserIdByToken(this.token, function (data) {
                if (data.id == userDetails.id) {
                    _this.userId = userDetails.id;
                    _this.$rootScope.userDetails = _this.StorageService.get('userDetails');
                    _this.email = _this.$rootScope.userDetails.emailId;
                    _this.isUserAlreadyLoggedIn = true;
                }
                else {
                    _this._logoutAndRedirectUser(false);
                }
                _this.loadingFlag = false;
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this._logoutAndRedirectUser(false);
            this.loadingFlag = false;
        }
    };
    TokenLoginPageController.prototype._logoutAndRedirectUser = function (redirectFlag) {
        var _this = this;
        var rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
        var userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.StorageService.resetBrowserStorage();
        if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
            if (angular.isDefined(userDetails) && (userDetails !== null)) {
                this.StorageService.setCookie('logoutemail', userDetails.emailId);
            }
        }
        this.authService.logout(function (data) {
            _this.StorageService.removeCookie('connect.sid');
            _this.StorageService.remove('companyDetails');
            _this.StorageService.remove('SelectedHostCompany');
            _this.StorageService.remove('userDetails');
            if (redirectFlag) {
                _this.$state.go('login', null, { reload: true });
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    TokenLoginPageController.prototype.successCallback = function (tokenResponse) {
        var _this = this;
        if (!this.isUserAlreadyLoggedIn) {
            this.StorageService.removeCookie('logoutemail');
            this._manageCookiesandRememberMe(tokenResponse);
            var userObj = {};
            this.$rootScope.userDetails = userObj;
            console.log('createUserDetailsObject(data) : ' + angular.toJson(this._createUserDetailsObject(tokenResponse)));
            this.StorageService.set('userDetails', this._createUserDetailsObject(tokenResponse), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
            this.$rootScope.userDetails = this.StorageService.get('userDetails');
        }
        if (this.action === 'Outreach') {
            this.$rootScope.userActive = false; // Remove After converting to angular
            this.$state.go('candidateOutreach', { outreachId: this.outreachId, candidateId: this.candidateId, companyId: this.companyId, tokenId: this.token });
        }
        else {
            this._getTokenPayload(function (tokenData) {
                _this.tokenData = tokenData;
                _this.userIdsArray.push(_this.$rootScope.userDetails.id);
                var workflowSteps = {
                    PhoneScreen: 'ps',
                    Interview: 'in'
                };
                if (workflowSteps[_this.action]) {
                    _this.authenticatedFlag = true;
                    _this.$state.go('conference', {
                        sh: _this.tokenData.meetingScheduleId,
                        ws: workflowSteps[_this.action],
                        mode: _this.tokenData.meetingMode
                    });
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    TokenLoginPageController.prototype.errorCallback = function (tokenResponse) {
        this.alertsAndNotificationsService.showBannerMessage(tokenResponse.message, 'danger');
    };
    TokenLoginPageController.prototype._getTokenPayload = function (successCallback, errorCallback) {
        this.authService.getTokenPayload(this.token, this.$rootScope.userDetails.id, function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    /**
     * This method is invoked from login success call.
     * It manages cookis storage and rememberme status
     */
    TokenLoginPageController.prototype._manageCookiesandRememberMe = function (data) {
        this.rememberme = true;
        if (this.rememberme) {
            this.StorageService.setCookie('rememberme', true, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
        }
        else {
            this.StorageService.setCookie('rememberme', false, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
        }
        this.StorageService.setCookie('refreshtoken', data.refreshToken, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
    };
    TokenLoginPageController.prototype._createUserDetailsObject = function (data) {
        var obj = {};
        obj.company = {};
        obj.plan = {};
        obj.id = data.id;
        obj.firstname = data.firstname;
        obj.lastname = data.lastname;
        obj.emailId = data.emailId;
        obj.companyId = data.companyId;
        // obj.accesstoken = data.token;
        obj.company.companyId = data.company.companyId;
        obj.company.companyName = data.company.companyName;
        obj.company.companyType = data.company.companyType;
        obj.company.companyState = data.company.companyState;
        obj.company.companyStateLabel = data.company.companyState == 'SoftHold' ? 'Soft Hold' : data.company.companyState;
        obj.company.message = data.company.message;
        obj.plan.planName = data.planMinDto.planName;
        obj.plan.planType = data.planMinDto.planType;
        obj.plan.startDate = this.moment(data.planMinDto.planStartDate);
        obj.plan.endDate = this.moment(data.planMinDto.planEndDate);
        obj.plan.message = "";
        obj.accountState = data.accountState;
        obj.shouldPopupBeDisplayed = data.shouldPopupBeDisplayed;
        if (!_.isNull(data.roleScreenRef)) {
            obj.roleScreenRef = this._createRoleScreenRefObj(data.roleScreenRef.role);
        }
        else if (!_.isNull(data.role)) {
            obj.roleScreenRef = this._createRoleScreenRefObj(data.role);
        }
        return obj;
    };
    TokenLoginPageController.prototype._createRoleScreenRefObj = function (role) {
        var roleObj = {};
        roleObj.role = {};
        roleObj.role.id = role.id;
        roleObj.role.name = role.name;
        // roleObj.screen = manageScreenListforRoles(roleScreenRef.screen);
        return roleObj;
    };
    TokenLoginPageController.prototype.actionSaveCallback = function () {
        var _this = this;
        if ((this.action == 'PhoneScreen' || this.action == 'Interview') && !this.isUserAlreadyLoggedIn) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-info' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: "This action is a one time action. It will save and log you out. If you wish to continue entering feedback click 'Cancel'. If you are done, click 'Ok'.",
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Ok',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this._logoutAndRedirectUser(true);
                    }
                    else {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
    };
    return TokenLoginPageController;
}());
export { TokenLoginPageController };
TokenLoginPageController.$inject = ['$rootScope', '$state', '$scope', 'modalService', 'authService', 'moment', 'StorageService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './token-login-page.html';
import * as TEMPLATE from 'raw-loader!./token-login-page.html';
export var TokenLoginPageComponent = {
    selector: 'tokenLoginPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/tokenLogin/token-login-page.html',
        template: TEMPLATE.default,
        controller: TokenLoginPageController
    }
};
//# sourceMappingURL=token-login-page.component.js.map